import React, { FC } from "react"
import { Icon, IconProps } from "./Icon"

export const IconDeselect: FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M13 13l3 3m0 0l3 3m-3-3l3-3m-3 3l-3 3m3 7c-5.523 0-10-4.477-10-10S10.477 6 16 6s10 4.477 10 10-4.477 10-10 10z"
      ></path>
    </Icon>
  )
}

export default IconDeselect
